import React from "react";
import { withSentryTracing } from "supercell-frontend-base/src/tracing/sentry";
import { AppController } from "./controller";
import { SnowplowContextProvider } from "supercell-frontend-base/src/analytics/snowplow";
import {
    BoomBeachGameParams,
    BoomBeachGameParamsSchema,
} from "../../validation/game-params";
import {
    GameParamsContextProvider,
    GameParamsState,
} from "supercell-frontend-base/src/stores/gameParams";

type WithGameParamsProps = {
    initialState: GameParamsState;
    sendCommand: (command: string) => void;
};

const WithGameParams = (props: WithGameParamsProps) => {
    return (
        <SnowplowContextProvider
            config={{
                appId: window.SNOWPLOW_APP_ID,
                collectorUrl: window.SNOWPLOW_COLLECTOR_URL,
            }}
        >
            <GameParamsContextProvider<BoomBeachGameParams>
                initialState={props.initialState}
                gameParamsParser={BoomBeachGameParamsSchema}
            >
                <AppController sendCommand={props.sendCommand} />
            </GameParamsContextProvider>
        </SnowplowContextProvider>
    );
};

export const App = withSentryTracing(
    WithGameParams as (props: unknown) => JSX.Element,
);
